import React, { useState, useEffect, useLayoutEffect } from "react";
import "./styles.scss";

const PdfViewer = ({ url, title, ...props }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [unmountIframe, setUnmountIframe] = useState(false);

  useEffect(() => {
    if (!iframeLoaded) {
      const timeout = setTimeout(() => setUnmountIframe(true), 10000);
      return () => clearTimeout(timeout);
    }
  }, [iframeLoaded]);

  useLayoutEffect(() => {
    if (unmountIframe) {
      setUnmountIframe(false);
    }
  }, [unmountIframe]);

  return (
    <>
      {!iframeLoaded && (
        <div className="pdf-load-container">
          <div className="loader large" />
        </div>
      )}
      {!unmountIframe && (
        <iframe
          key={url}
          src={`https://docs.google.com/viewerng/viewer?url=${url}&embedded=true`}
          title={title}
          frameBorder="none"
          className="full-page-pdf"
          onLoad={() => setIframeLoaded(true)}
          {...props}
        />
      )}
    </>
  );
};

export default PdfViewer;
